// extracted by mini-css-extract-plugin
module.exports = {"analysPieBox":"index_analysPieBox_1fQ2l","analysPie":"index_analysPie_3kmQf","pieDesc":"index_pieDesc_NoZFT"};